import { Component, OnInit } from '@angular/core';
import { FailureFormBaseComponent } from '../failure-form-base/failure-form-base.component';
import { StoreService } from '../../../../../../services/store.service';
import { AttachmentService } from '../../../../../../services/attachment.service';
import { DialogService } from '../../../../../../services/dialog.service';
import { FormBuilder } from '@angular/forms';
import { buildFailureForm } from '../failure-form.utils';
import { ConnectionStatusService } from 'src/app/services/connection-status.service';

@Component({
  selector: 'failure-form-v2',
  templateUrl: './failure-form-v2.component.html',
  styleUrls: ['../failure-form.scss']
})
export class FailureFormV2Component extends FailureFormBaseComponent implements OnInit {
  protected readonly hintKey = 'UPLOAD_2_10_FILES';
  protected networkStatus$ = this.connectionStatusService.networkStatus$;
  constructor(
    protected override storeService: StoreService,
    protected override attachmentService: AttachmentService,
    protected override dialogService: DialogService,
    private readonly fb: FormBuilder,
    private connectionStatusService: ConnectionStatusService
  ) {
    super(storeService, attachmentService, dialogService);
  }

  ngOnInit(): void {
    this.form = buildFailureForm(this.fb, this.data.disabled, this.getDefectName());
    this.fillFormWithData();
  }

  get isUploadDisabled(): boolean {
    return (this.form.get('photos')?.value?.length ?? 0) >= 10;
  }

  override validatePhoto(): boolean {
    const photoControl = this.form.get('photos');
    return photoControl?.value.length > 1;
  }

  override showPhotoValidationMessage() {
    this.storeService.showWarningMsg('2_PHOTO_REQUIRED');
  }

  override handleSubmit() {
    this.closeDialogEvent.emit(this.preparePayload());

    if (this.form.value.category === this.FAILURE_CATEGORY.RED) {
      this.storeService.showWarningMsg('RED_CATEGORY_WARNING');
    }
  }
}
